import { Box, Typography } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import TkButton from "../../../../atoms/TkButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TkToolTip from "../../../../atoms/TkToolTip";
import { useNavigate } from "react-router-dom";
import "./_style.scss";
import { GlobalContext } from "../../../../../context/globalContext";

/**
 * TkQaButton「困ったときは」ボタン部品
 *
 * @param なし
 * @returns 「困ったときは」ボタン
 */
const TkQaButton: React.FC = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);

  const qaRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  // ページ遷移のハンドラー関数
  const handleJumpPage = () => {
    onClose();
    navigate("/SCRC020002");
  };

  const handleOpenChat = () => {
    onClose();
    setState({
      ...state,
      chatOpen: true,
    });
  };

  // クロスボタン
  const onClose = () => {
    setOpen(!open);
  };

  return (
    <Box>
      <TkButton
        ml
        onClick={() => {
          setOpen(!open);
        }}
        ref={qaRef}
        className="tkQaButtonParent"
        startIcon={<HelpOutlineIcon />}
      >
        <Typography className="tkButtonTextParent">困ったときは</Typography>
      </TkButton>
      <TkToolTip open={open} anchorEl={qaRef.current} placement="bottom-start">
        <Box className="tkQaButtonGroup">
          <TkButton onClick={handleJumpPage} className="tkQaButtonChildren">
            マニュアル
          </TkButton>
          <TkButton onClick={handleOpenChat}>チャットQ&A</TkButton>
        </Box>
      </TkToolTip>
    </Box>
  );
};

export default TkQaButton;
